module.exports = __webpack_public_path__ + "media/images/img_sasaki-e146f46df371f470be579e9ff1259f7f.jpg";